<template>
      <layout-basic>
        <Breadcrumb/>
        <v-container fluid style="margin-bottom: 45px">
          <v-row>
            <v-col md="12">
              <HeaderComponent title="Resource Category" subTitle="Choose a category to view relevant documents."/>
            </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
              <ResourseCategory/>
              </v-col>
            </v-row>
            </v-container>
        </layout-basic>
  </template>
  
  <script>
  import LayoutBasic from '@/layouts/Dashboard';
  import HeaderComponent from '@/components/HeaderComponent'
  import ResourseCategory from '@/components/ResourseCategory';
  import Breadcrumb from '@/components/Breadcrumb';
  export default {
    name: 'Resources',
    components: {
      LayoutBasic,
      HeaderComponent,
      ResourseCategory,
      Breadcrumb
    }
  }
  </script>
  
  <style scoped>
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
 }
  </style>
